import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  display: inline-block;
  padding: 40px 20px;
  text-align: center;

  &:focus {
    outline: 0;
  }

  ${media.medium`
    padding: calc(10vw - 90px) 4vw;
  `}
`;
